(() => {
  const init = (root) => {
    if (root.dataset.heroReady) return;
    root.dataset.heroReady = 'true';
    const video = root.querySelector('video');
    if (!video) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    video.addEventListener('playing', () => {
      root.classList.add('is-video-ready');
    });
    video.addEventListener('error', () => {
      root.classList.remove('is-video-ready');
    });
    reduced.addEventListener('change', () => {
      if (reduced.matches) video.pause();
      else video.play().catch(() => {});
    });
    if (!reduced.matches) video.play().catch(() => {});
  };
  const initAll = (root = document) => root.querySelectorAll('[data-ll-home-hero]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
